import axios from 'axios';
import { CHANGE_QTY } from './api.config';

export default async function ({ id, qty }) {
    const { data } = await axios({
        method: 'post',
        url: CHANGE_QTY,
        params: {
            [`cart[${id}][qty]`]: qty,
        },
    });
    return data;
}
